import React from "react";
import { Input } from "reactstrap";

export interface Props {
    label?: string;
    key_label: string;
    isChecked?: boolean;
    isRequired?: boolean;
    isShowCheckbox?: boolean;
    className?: string;
    classNameBabel?: string;
    onChange?: (key: string, value: boolean) => void;
}

const LabelCheckbox = ({
    label = '',
    key_label = '',
    isChecked = false,
    isRequired = false,
    isShowCheckbox = false,
    className = 'mb-1',
    classNameBabel = '',
    onChange = () => { },
}: Props) => {
    const handleChange = (event: any) => {
        onChange(key_label, event?.target.checked);
    };
    return (
        <React.Fragment>
            <div className={`form-check form-check-inline  me-1 ${isShowCheckbox ? '' : 'ps-0'} ${className}`}>
                {isShowCheckbox ? <Input className="form-check-input"
                    type="checkbox"
                    role="checkbox"
                    id={`cb_${key_label}`}
                    name={`cb_${key_label}`}
                    checked={isChecked}
                    onChange={handleChange}
                /> : <></>}
                <label className={`form-check-label ${classNameBabel}`} htmlFor={`cb_${key_label}`}>
                    {label}
                    {isRequired && <span className="text-danger"> *</span>}
                </label>
            </div>
        </React.Fragment >
    );
};

export default React.memo(LabelCheckbox);
